class PrintVoucherOverviews {
    constructor(Alert, $http, locale, ResourceCommon) {
        this.key = 'print-voucher-overviews-for-invoices';
        this.title = 'Print Voucher Overviews';
        this.level = 'selected';
        this.alert = Alert;
        this.locale = locale;
        this.api = $http;
        this.resourceCommon = ResourceCommon;
    }

    action({}, store) {
        return this.locale.ready(['categories', 'sweetalerts'])
            .then(() => {
                this.api.post('vouchers/print-overviews-for-invoices', {
                    invoices: store.getters.selectedFilters
                }).then(() => {
                    store.dispatch('getData');
                    this.alert.success('Job scheduled', 'The job was scheduled. The documents will be generated and printed now.');
                }, err => this.alert.handle(err))
            });
    }
}

angular
    .module('festzelt-os.billing.invoices')
    .factory('printVoucherOverviews', [
        'Alert',
        '$http',
        'locale',
        'ResourceCommon',
        (Alert, $http, locale, ResourceCommon) => new PrintVoucherOverviews(Alert, $http, locale, ResourceCommon)
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/billing/invoices/workflows/print-voucher-overviews-for-invoices.js